import * as React from 'react'

const FailureInfoIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M32.003 5.333C17.309 5.333 5.336 17.308 5.336 32c0 14.694 11.973 26.667 26.667 26.667 14.693 0 26.666-11.974 26.666-26.667 0-14.693-11.973-26.666-26.666-26.666Zm-2 16c0-1.093.906-2 2-2 1.093 0 2 .907 2 2v13.334c0 1.093-.907 2-2 2-1.094 0-2-.907-2-2V21.333Zm4.453 22.347c-.133.347-.32.614-.56.88a3.08 3.08 0 0 1-.88.56c-.32.134-.667.214-1.013.214-.347 0-.694-.08-1.014-.214a3.08 3.08 0 0 1-.88-.56 2.753 2.753 0 0 1-.56-.88 2.653 2.653 0 0 1-.213-1.013c0-.347.08-.694.213-1.014.134-.32.32-.613.56-.88.267-.24.56-.426.88-.56a2.667 2.667 0 0 1 2.027 0c.32.134.613.32.88.56.24.267.427.56.56.88.133.32.213.667.213 1.014 0 .346-.08.693-.213 1.013Z"
      fill={props.fill}
    />
  </svg>
)

FailureInfoIcon.defaultProps = {
  height: 64,
  width: 64,
  fill: '#DC2626'
}

export { FailureInfoIcon }
